import { Injectable } from "@angular/core";

import { BaseResponseDTO } from "@app/shared/dto/base-responseDTO";
import { BaseResponseVO } from "@app/shared/vo/base-responseVO";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { MapperDettaglioErrore } from "./mapper-dettaglio-errore";

@Injectable({
  providedIn: "root"
})
export class MapperBaseResponse
  implements MapperInterface<BaseResponseDTO, BaseResponseVO> {
  constructor(private mapperDettaglioErrore: MapperDettaglioErrore) { }

  convertVoToDto(baseResponseVO: BaseResponseVO): BaseResponseDTO {
    throw new Error("Method not implemented.");
  }

  convertDtoToVo(baseResponseDTO: BaseResponseDTO): BaseResponseVO {
    console.log("[MapperBaseResponse] baseResponseDTO => baseResponseVO");
    let baseResponseVO: BaseResponseVO;
    baseResponseVO = new BaseResponseVO();
    //baseResponseVO.stato = baseResponseDTO.stato;
    baseResponseVO.descrizione = baseResponseDTO.descrizione;
    if (baseResponseDTO.errori != null) {
      baseResponseVO.errori = this.mapperDettaglioErrore.convertListDtoToVo(baseResponseDTO.errori)
    }
    baseResponseVO.stato = baseResponseDTO.stato;
    console.log("baseResponseDTOtoVO - fine");
    return baseResponseVO || new BaseResponseVO();
  }

  convertListVoToDto(comunicazioniVOList: BaseResponseVO[]): BaseResponseDTO[] {
    throw new Error("Method not implemented.");
  }
  convertListDtoToVo(
    comunicazioniDTOList: BaseResponseDTO[]
  ): BaseResponseVO[] {
    throw new Error("Method not implemented.");
  }
}
